import React from 'react';
import styled from '@emotion/styled';
import * as color from '../color';

export default function InfoBanner() {
  return (
    <Banner role="status" aria-live="polite">
      <Text>
        <strong>NVDB Rapporter får nytt brukergrensesnitt!</strong> Som en del av utviklingsarbeidet ønsker vi innspill
        fra deg som bruker:
      </Text>
      <Link href={'https://forms.cloud.microsoft/e/mmqtb2P7fG'} target={'_blank'} rel={'noopener noreferrer'}>
        Gi din tilbakemelding her
      </Link>
    </Banner>
  );
}

const Banner = styled.section`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  padding: 0.75rem 1rem;
  border-top: 1px solid ${color.orange600};
  border-bottom: 1px solid ${color.orange600};
  background: ${color.orange100};
  color: ${color.gray900};
`;

const Text = styled.p`
  margin: 0;
  font-size: 0.95rem;

  strong {
    font-family: 'LFT Etica Semibold', 'LFT Etica';
    font-weight: bold;
  }
`;

const LinkRow = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

const Link = styled.a`
  color: ${color.blue800};
  font-weight: 600;
  text-decoration: underline;

  &:hover {
    color: ${color.blue900};
  }
`;
